import { useIsDesktopScreen } from './useIsDesktopScreen'
import { useIsLargeScreen } from './useIsLargeScreen'
import { useIsMobileScreen } from './useIsMobileScreen'

export const useScreenSizeFlags = (): {
  isMobileScreenSize: boolean
  isDesktopScreenSize: boolean
  isLargeDesktopScreenSize: boolean
} => {
  const isMobileScreenSize = useIsMobileScreen()
  const isDesktopScreenSize = useIsDesktopScreen()
  const isLargeDesktopScreenSize = useIsLargeScreen()

  return { isMobileScreenSize, isDesktopScreenSize, isLargeDesktopScreenSize }
}
